import React, { useState } from "react";
import { TextField, Button, Grid, Typography, Box } from "@mui/material";
import axios from "axios";
import { BASE_URL } from "../../App";

const WarrantyCancel = () => {
  const [serialNo, setSerialNo] = useState("");
  const [error, setError] = useState("");
  const login_id = localStorage.getItem("LOGIN_ID");
  const BRANCH_CODE = localStorage.getItem("BRANCH_CODE");

  const removeWarranty = async (serialNo, loginId) => {
    try {
      const response = await axios.post(`${BASE_URL}/removeWarranty`, {
        serial_no: serialNo,
        loginId: loginId, // use the function argument here, not the outer variable
      });
      alert(response.data.message);
    } catch (error) {
      if (error.response) {
        alert(error.response.data.error || error.response.data.message);
      } else {
        alert("An unexpected error occurred");
      }
    }
  };
  

  const handleRemoveWarranty = () => {
    if (!serialNo) {
      setError("Please enter a serial number");
      return;
    }
    setError("");
    removeWarranty(serialNo, login_id);
  };

  return (
    <Box sx={{ maxWidth: 600, mx: "auto", mt: 4, p: 2 }}>
      {/* <Typography variant="h6" gutterBottom textAlign="center">
        WARRANTY CANCEL
      </Typography> */}

      <Grid container spacing={1} alignItems="center">
        <Grid item xs={12} sm={8}>
          <TextField
            label="Serial Number"
            variant="outlined"
            fullWidth
            size="small"
            value={serialNo}
            onChange={(e) => setSerialNo(e.target.value)}
            error={!!error}
            helperText={error}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            fullWidth
            onClick={handleRemoveWarranty}
            sx={{ height: "40px" }}
          >
            Remove
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default WarrantyCancel;
